import CardFooterAction from './CardFooterAction';
import { Flex } from 'foundations-components/components/Flex';
import { ListItem } from 'foundations-components/transitional/components/List';
import { Collapser } from 'foundations-components/transitional/components/Collapser';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardFooterActions = ({
  primaryActionConfig,
  secondaryActionConfig,
  toObjectTypeId,
  usageTracker
}) => {
  if (!primaryActionConfig && !secondaryActionConfig) {
    return null;
  }
  if (primaryActionConfig && !secondaryActionConfig) {
    return /*#__PURE__*/_jsx(CardFooterAction, {
      actionConfig: primaryActionConfig,
      toObjectTypeId: toObjectTypeId,
      usageTracker: usageTracker,
      variant: "primary"
    });
  }
  return /*#__PURE__*/_jsx(Collapser, {
    fallback: /*#__PURE__*/_jsx(Dropdown, {
      buttonText: I18n.text('cardAssociatedObjects.cardFooterActionsDropdown'),
      buttonSize: 'xs',
      buttonUse: 'tertiary-extra-light',
      children: /*#__PURE__*/_jsxs(List, {
        children: [primaryActionConfig && /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(CardFooterAction, {
            actionConfig: primaryActionConfig,
            toObjectTypeId: toObjectTypeId,
            usageTracker: usageTracker,
            variant: "primary"
          })
        }), secondaryActionConfig && /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(CardFooterAction, {
            actionConfig: secondaryActionConfig,
            toObjectTypeId: toObjectTypeId,
            usageTracker: usageTracker,
            variant: "secondary"
          })
        })]
      })
    }),
    children: /*#__PURE__*/_jsxs(Flex, {
      gap: "300",
      alignItems: "center",
      children: [primaryActionConfig && /*#__PURE__*/_jsx(CardFooterAction, {
        actionConfig: primaryActionConfig,
        toObjectTypeId: toObjectTypeId,
        usageTracker: usageTracker,
        variant: "primary"
      }), secondaryActionConfig && /*#__PURE__*/_jsx(CardFooterAction, {
        actionConfig: secondaryActionConfig,
        toObjectTypeId: toObjectTypeId,
        usageTracker: usageTracker,
        variant: "secondary",
        use: "link"
      })]
    })
  });
};
export default CardFooterActions;